import { c as _c } from "react/compiler-runtime";
import dayjs from "dayjs";
import "dayjs/locale/fr";
interface ModalEventViewHeaderProps {
  startDate?: string;
}
export const ModalEventViewHeader = t0 => {
  const $ = _c(4);
  const {
    startDate
  } = t0;
  if (!startDate) {
    return null;
  }
  let t1;
  if ($[0] !== startDate) {
    t1 = dayjs(startDate).format("DD/MM/YYYY");
    $[0] = startDate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex justify-center w-full"><h2 className="text-xl font-semibold mt-3 mb-0">Réunion du {t1}</h2></div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};